import React, { ReactElement, CSSProperties } from 'react'
import { Icon, IconProps } from '@ally/metronome-ui'
import { muiWarningFill } from '@ally/metronome-icons'
import styled from 'styled-components'

const StyledWarningIcon = styled(Icon)`
  margin-right: 8px;
  vertical-align: text-bottom;
`

/**
 * Warning Icon
 *
 * `aria-hidden=true` by default
 */
export const WarningIcon = (
  props: Omit<IconProps, 'icon'> & { style?: CSSProperties },
): ReactElement => {
  return (
    <StyledWarningIcon
      icon={muiWarningFill}
      fill="warning"
      size="md"
      aria-hidden
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  )
}
